"use client";

import { cn } from "@homeinstead/ui";
import { NavigationBottomPanel } from "~care/components/ui/NavigationMenu/PPC/NavigationBottomPanel";
import { useBottomPanel } from "~care/hooks/useBottomPanel";

interface HeroProps {
  className?: string;
  children?: React.ReactNode;
}

export const Hero = ({ className, children }: HeroProps) => {
  // props used for determining when the bottom panel (fixed bottom CTA)
  // should show this is used on all invocations of the Hero and if we
  //  don't want this on a future lander, this would need to be refactored
  const { heroRef, showBottomPanel } = useBottomPanel();

  return (
    <>
      <section
        className={cn(
          "flex h-[864px] flex-col items-center px-4 py-12 sm:px-10 xl:items-start xl:px-[152px]",
          className,
        )}
        ref={heroRef}
      >
        {children}
      </section>
      {/* the fixed panel shows when the hero leaves the viewport (less than a certain %) */}
      <NavigationBottomPanel showBottomPanel={showBottomPanel} />
    </>
  );
};
